import { combineReducers } from 'redux';

import breadcrumb from './breadcrumb';
import infobar from './infobar';
import currentMedia from './mp_currentMedia';
import isAutoPlay from './mp_isAutoPlay';
import isPlaying from './mp_isPlaying';
import playlist from './mp_playlist';
import mpPlayPause from './mp_playpause';
import translatedUrls from './translationUrl';

export default combineReducers({
	translatedUrls,
	playlist,
	isAutoPlay,
	mpPlayPause,
	isPlaying,
	currentMedia,
	breadcrumb,
	infobar
});
